/* eslint-disable import/no-cycle */
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { setSelectedTrack } from 'redux-core/tracks/actions';

const mapDispatchToProps = { push, setSelectedTrack };

export default connect(undefined, mapDispatchToProps);
